import { OrderProduct, SetProductWithParentId } from 'common/types';

export const isLastProductForShopper = (shopperProducts: OrderProduct[]) => {
	if (shopperProducts.length <= 1) {
		let isLastProduct = false;
		shopperProducts.forEach((p) => {
			if (p.set && p.setProducts) {
				const activeSetProducts = p.setProducts.filter((setP) => !setP.removedFromParent);
				if (activeSetProducts.length <= 1) {
					isLastProduct = true;
				}
			} else {
				isLastProduct = true;
			}
		});
		return isLastProduct;
	}
	return false;
};

export const areProductsSelectedForCurrentShopper = (
	shopperProducts: OrderProduct[],
	selectedNonSetProductIds: string[],
	selectedSetProducts: SetProductWithParentId[],
) => {
	if (
		getSelectedNonSetProductIdsForCurrentShopper(shopperProducts, selectedNonSetProductIds)
			.length ||
		getSelectedSetProductsForCurrentShopper(shopperProducts, selectedSetProducts).length
	) {
		return true;
	}
	return false;
};

export const areAllProductsSelectedForCurrentShopper = (
	shopperProducts: OrderProduct[],
	selectedNonSetProductIds: string[],
	selectedSetProducts: SetProductWithParentId[],
) => {
	const selectedNonSetProductIdsForShopper = getSelectedNonSetProductIdsForCurrentShopper(
		shopperProducts,
		selectedNonSetProductIds,
	);
	const selectedSetProductsForShopper = getSelectedSetProductsForCurrentShopper(
		shopperProducts,
		selectedSetProducts,
	);
	const selectedShopperProducts = shopperProducts.filter(
		(p) =>
			selectedNonSetProductIdsForShopper.includes(p.id) ||
			(!!p.setProducts.length &&
				selectedSetProductsForShopper.filter((sp) => sp.parentId === p.id).length ===
					p.setProducts.length),
	);
	return shopperProducts.length === selectedShopperProducts.length;
};

export const getSelectedNonSetProductIdsForCurrentShopper = (
	shopperProducts: OrderProduct[],
	selectedNonSetProductIds: string[],
) => {
	const selectedNonSetProductIdsForCurrentShopper = selectedNonSetProductIds.reduce(
		(selectedIds: string[], currentId) => {
			if (shopperProducts.some((p) => p.id === currentId)) {
				selectedIds.push(currentId);
			}
			return selectedIds;
		},
		[],
	);
	return selectedNonSetProductIdsForCurrentShopper;
};

export const getSelectedSetProductsForCurrentShopper = (
	shopperProducts: OrderProduct[],
	selectedSetProducts: SetProductWithParentId[],
) => {
	const selectedSetProductsForCurrentShopper = selectedSetProducts.reduce(
		(selectedProducts: SetProductWithParentId[], currentProduct) => {
			if (shopperProducts.some((p) => p.id === currentProduct.parentId)) {
				selectedProducts.push(currentProduct);
			}
			return selectedProducts;
		},
		[],
	);
	return selectedSetProductsForCurrentShopper;
};
